'use strict';
mpangoApp.controller('AuthController', AuthController);
function AuthController($scope, $auth, $state, $http, $rootScope,Notification,Muser,Mreports,$window,$location) {
    $scope.downloadManual = function(fname) {
        Mreports.downloadManual(fname).success(function  (data,status) {
            var url = 'index.php/api/downloadmanual?data='+fname;
            $window.open(url);
        }).error(function(data,status){
            Notification.error({message: 'Something went wrong..', delay: 3000});
        });
    };
    $scope.showParticles = true;
    var vm = this;    
    $scope.loginError = false;
    $scope.loginErrorText;
    $scope.datePickerOpen = function() {
        $scope.popup.opened = true;
    };
    $scope.popup = {
        opened: false
    };
    vm.login = function() {
        var credentials = {
            email: vm.email,
            password: vm.password
        }
        $auth.login(credentials).then(function() {
            return $http.get('api/authenticate/user');
        }, function(error) {
            vm.email = "";
            vm.password = "";
            $scope.loginError = true;
            $scope.loginErrorText = 'Login information incorrect!';
       }).then(function(response) {
            var user = JSON.stringify(response.data.user);
            localStorage.setItem('user', user);
            $rootScope.authenticated = true;
            $rootScope.currentUser = response.data.user;
            $state.go('dashboard');
        });
    }
    vm.signup = function(valid) {
        if (valid == true) {
            var credentials = {
            first_name: vm.first_name,
            last_name: vm.last_name,
            email: vm.email,
            phone: vm.phone,
            event_name: vm.event_name,
            event_date: vm.event_date,
            location: vm.location
        }
            $auth.signup(credentials).then(function(data) {
                $state.go('auth');
                Notification.success({message: data.data.message, delay: 15000});
            }, function(error) {
                vm.first_name = error.config.data.first_name;
                vm.last_name = error.config.data.last_name;
                vm.email = error.config.data.email;
                vm.phone = error.config.data.phone;
                vm.event_name = error.config.data.event_name;
                vm.event_date = error.config.data.event_date;
                vm.location = error.config.data.location;
                $scope.loginError = true;
                $scope.loginErrorTexts = error.data;
            });
        };
    }
    vm.reset = function(valid) {
        if (valid == true) {
            var credentials = {
            email: vm.email
        }
            Muser.pReset(credentials).then(function(data) {
                $state.go('auth');
                Notification.success({message: data.data.message, delay: 15000});
            }, function(error) {
                vm.email = error.config.data.email;
                $scope.loginError = true;
                $scope.loginErrorText = error.data.message;
            });
        };
    }
}
AuthController.$inject = ['$scope','$auth', '$state', '$http', '$rootScope','Notification','Muser','Mreports','$window'];
mpangoApp.directive('particlesDrv', ['$window', '$log', particlesDrv]);

function particlesDrv($window, $log) {
  return {
    restrict: 'A',
    template: '<div class="particleJs" id="particleJs"></div>',
    link: function(scope, element, attrs, fn) {
    $window.particlesJS('particleJs', {
        particles: {
          number: {
            value: 350,
            density: {
              enable: true,
              value_area: 800
            }
          },
          color: {
            value: '#F5D76E'
          },
          shape: {
            type: "circle",
            polygon: {
              nb_sides: 5
            }
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false
            }
          },
          size: {
            value: 5,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false
            }
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: '#F5D76E',
            opacity: 0.4,
            width: 1
          },
          move: {
            enable: true,
            speed: 6,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200
            }
          }
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'bubble'
            },
            onclick: {
              enable: true,
              mode: 'repulse'
            },
            resize: true
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 1
              }
            },
            bubble: {
              distance: 400,
              size: 4,
              duration: 2,
              opacity: 8,
              speed: 3
            },
            repulse: {
              distance: 100,
              duration: 0.4
            },
            push: {
              particles_nb: 4
            },
            remove: {
              particles_nb: 2
            }
          }
        },
        retina_detect: true
      });
    }
  };
}